import React from "react";
import { Link } from "react-router-dom";
import Chatbot from "./Chatbot";

function Footer() {
  return (
    <>
      <footer className="bg-secondary">
        <div className="container pt-2-9 pt-lg-7">
          <div className="row mb-2-9">
            {/* Column 1: About */}
            <div className="col-md-6 col-lg-4 mb-2-2 mb-lg-0">
              <div className="pe-md-5">
                <div className="footer-logo mb-3">
                  <Link to="/">
                    <img
                      src="/img/logos/footer-light-logo.png"
                      alt="Shamayita Math Logo"
                      className="img-fluid"
                      style={{ maxWidth: "300px" }}
                    />
                  </Link>
                </div>
                <p className="text-white mb-1-6">
                  Indian non-governmental organization that envisions empowering
                  marginalized communities through self-knowledge and
                  self-consciousness, irrespective of social background,
                  beliefs, or religious affiliations.
                </p>
                <ul className="social-icon-style3 list-unstyled mb-0">
                  <li>
                    <a href="https://www.facebook.com/www.shamayitamath.org?mibextid=ZbWKwL"target="blank">
                      <i className="fa-brands fa-facebook-f" />
                    </a>
                  </li>
                  <li>
                    <a href="https://youtube.com/@shamayitamath2956?si=s7HKE99MD6pY6Kpb"target="blank">
                      <i className="fa-brands fa-youtube" />
                    </a>
                  </li>
                  <li>
                    <a href="https://www.linkedin.com/company/shamayitamath/?viewAsMember=true"target="blank">
                      <i className="fa-brands fa-linkedin-in" />
                    </a>
                  </li>
                  <li>
                    <a href="https://www.instagram.com/shamayitamath?utm_source=ig_web_button_share_sheet&igsh=ODdmZWVhMTFiMw=="target="blank">
                      <i className="fa-brands fa-instagram" />
                    </a>
                  </li>
                </ul>
              </div>
            </div>

            {/* Column 2: Contact Info */}
            <div className="col-md-6 col-lg-4 mb-2-2 mb-lg-0">
              <div className="ps-md-1-9 ps-xxl-7 pe-lg-1-9 pe-xl-6">
                <h3 className="h4 text-white mb-1-6 mb-md-1-9">Head Office</h3>
                <ul className="list-unstyled list-style09 mb-0">
                  <li>



                    <span>Address: </span>Ranbahal, Amarkanan, Bankura- 722133.

                  </li>
                  <li>
                    <span>Mail: </span>contactus@shamayitamath.in
                  </li>
                  <li>
                    <span>Phone: </span>(+91) 9064102591
                  </li>
                </ul>
              </div>
            </div>

            {/* Column 3: Newsletter */}
            <div className="col-md-6 col-lg-4">
              <h3 className="h4 text-white mb-1-6 mb-md-1-9">Our Newsletter</h3>
              <form className="quform newsletter-style04">
                <div className="quform-elements position-relative">
                  <div className="row">
                    <div className="col-md-12">
                      <div className="quform-element mb-4">
                        <div className="quform-input position-relative">
                          <input
                            className="form-control rounded-pill ps-4 px-7 border-color-transparent"
                            type="text"
                            name="email_address"
                            placeholder="Subscribe with us"
                          />
                          <i className="fa fa-user position-absolute right-5 top-50 translate-middle text-secondary" />
                        </div>
                      </div>
                    </div>
                    <div className="col-md-12">
                      <div className="quform-submit-inner">
                        <button
                          className="btn-style3 white-hover rounded-pill border-0"
                          type="submit"
                        >
                          Subscribe Now
                        </button>
                      </div>
                      <div className="quform-loading-wrap">
                        <span className="quform-loading"></span>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>

          {/* Bottom row */}
          <div className="row border-top border-color-light-white align-items-center pt-1-6 pb-1-9">
          </div>
        </div>
      </footer>

      {/* Chatbot component কে footer এর বাইরে render করুন */}
      <Chatbot />
    </>
  );
}

export default Footer;
